import React from "react";
import "../../Assets/Css/HomeCss/Card.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSpecializationNames } from "../../Services/SpecializationService";

const avatarUrl = (avatar) => {
  if (!avatar) return "/img/doc-listing.jpg";
  if (/^https?:\/\//.test(avatar)) return avatar;
  return `https://backend.famracure.com/images/doctors/${avatar}`;
};

const Card = ({ doctor }) => {
  const { t } = useTranslation();
  const {
    id,
    firstname,
    lastname,
    avatar_doctor,
    experience_years,
    video_fee,
    clinic_fee,
    available,
  } = doctor;

  const specializations = getSpecializationNames(doctor);
  const bookingType = video_fee ? "video" : "clinic";

  return (
    <div className="doctor_card group h-full bg-white rounded-2xl shadow-md p-5 flex flex-col text-left transition-all duration-300 hover:-translate-y-1.5 hover:shadow-2xl">
      <div className="flex items-center gap-4">
        <img
          src={avatarUrl(avatar_doctor)}
          alt={`Dr. ${firstname} ${lastname}`}
          loading="lazy"
          className="w-20 h-20 flex-shrink-0 rounded-full object-cover border-2 border-blue-100 transition-transform duration-300 group-hover:scale-105"
        />
        <div className="min-w-0">
          <h3 className="text-base lg:text-lg font-semibold leading-snug text-gray-900 capitalize line-clamp-2 break-words">
            Dr. {firstname} {lastname}
          </h3>
          <span className="inline-flex items-center mt-1 px-2 py-0.5 rounded-full text-xs font-bold bg-green-100 text-green-800">
            <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            PMDC Verified
          </span>
        </div>
      </div>

      <div className="flex flex-wrap gap-1.5 mt-4 min-h-[28px]">
        {specializations.slice(0, 2).map((name) => (
          <span key={name} className="bg-blue-50 text-[#3d75ba] px-2.5 py-0.5 rounded-full text-xs font-semibold">
            {name}
          </span>
        ))}
        {specializations.length > 2 && (
          <span className="bg-gray-100 text-gray-600 px-2.5 py-0.5 rounded-full text-xs font-semibold">
            +{specializations.length - 2}
          </span>
        )}
      </div>

      <div className="mt-3 space-y-1.5 text-sm text-gray-700">
        {experience_years ? (
          <p className="flex items-center gap-2">
            <i className="fa-regular fa-briefcase-medical text-gray-400 w-4"></i>
            {experience_years} years experience
          </p>
        ) : null}
        {video_fee ? (
          <p className="flex items-center gap-2">
            <i className="fa-regular fa-video text-gray-400 w-4"></i>
            Video consultation: <span className="font-semibold">Rs. {video_fee}</span>
          </p>
        ) : null}
        {clinic_fee ? (
          <p className="flex items-center gap-2">
            <i className="fa-regular fa-hospital text-gray-400 w-4"></i>
            Clinic visit: <span className="font-semibold">Rs. {clinic_fee}</span>
          </p>
        ) : null}
        {available !== undefined && (
          <p className="flex items-center gap-2">
            <span className={`w-2.5 h-2.5 ml-[3px] mr-[3px] rounded-full ${available ? "bg-green-500" : "bg-red-500"}`}></span>
            {available ? "Available" : "Not available"}
          </p>
        )}
      </div>

      <div className="flex gap-2 mt-auto pt-5">
        <Link
          to={`/bookingappointment/${id}`}
          state={{ feeType: bookingType }}
          className="flex-1 text-center py-2 rounded-lg bg-[#0d63f3] text-white text-sm font-medium hover:bg-[#0a4bb4] transition-colors"
        >
          {t("Card.Reserve")}
        </Link>
        <Link
          to={`/doctor/View_Profile/${id}`}
          className="flex-1 text-center py-2 rounded-lg border-2 border-[#0d63f3] text-[#0d63f3] text-sm font-medium hover:bg-blue-50 transition-colors"
        >
          {t("Card.View_Profile")}
        </Link>
      </div>
    </div>
  );
};

export default Card;
